(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route);

    function route ($routeProvider, swifInterventionsConstant) {
        'ngInject';
        $routeProvider.when(swifInterventionsConstant.task.routes.barcode_view, {
            templateUrl: 'partials/openstc/tasks_barcode_view.html',
            controller: TasksBarcodeController,
            reloadOnSearch: false
        });
    }

    function TasksBarcodeController ($scope, $location, swifInterventionsService, swif) {
        'ngInject';
        var moduleInter = swifInterventionsService;
        console.log('init TasksBarcodeController');
        $scope.splitOn = ' ';
        // @return: from X,Y float returns [X.0, 0.Y]
        $scope.barcodeCallback = barcodeCallback;
        $scope.debug = $location.search().debug;
        $scope.currentAgentData = {};
        $scope.loading = {task: {}};
        //$scope.filterDateRange, $scope.filterState;
        createOrUpdateTasksCollection();
        $scope.model = {};
        initializeModel();
        updateFilters();


        $scope.$watch('tasks.currentItem', watchCurrentItem);
        $scope.$watch('model.user_id', watchUserId);
        $scope.$watch('model.service_id', watchServiceId);
        $scope.$watch('currentAgent', watchCurrentAgent);
        $scope.$watch('model.project_id', watchProjectId);
        $scope.$watch('model.category_id', watchCategoryId);
        $scope.$watchGroup(['filterDateRange', 'filterState'], watchGroupFilters);


        function splitFloat (val) {
            var intVal = parseInt(val, 10);
            var decimalVal = parseFloat(val) - intVal;
            return [intVal, decimalVal];
        }

        function applyDurationCode (source, newValue) {

            var key = newValue[0];
            var val = parseFloat(newValue.substring(1));
            var value = splitFloat(source);
            if(val >= 0.0) {
                // we handle following cases:
                // - 'h1', 'h0', ...
                // - 'm0.0', 'm0.25', 'm0.50', 'm0.75'
                // we DON'T handle: 'h1.5', 'm1.5', ...
                // in other words: hours handle 'int' part of the value
                // and minutes handle 'decimal' part of the value
                // we don't handle a mixin of this 2 uses (would result on unexpected additions)
                if (key === 'h') {
                    value[0] = val;
                } else if (key === 'm') {
                    value[1] = val;
                }
            }
            return value[0] + value[1];
        }

        function barcodeCallback (barcode) {
            // expects that barcode returns value like 'key_value'
            // custom callback, called when the barcode scanner select a new task
            // => add new task to items Array (if not yet present)
            // => and place it on top of the Array
            // @TODO: improvment => skip if new item is already the 1st of the list
            var placeTaskOnTop = function (item) {
                var newItem = item;
                var index = _.findIndex($scope.tasks.items, function (elt) {
                    return elt.id === item.id;
                });
                // if present, remove it from its current position
                // @TODO: little improvment => do not touch anything if index === 0
                if (index > -1) {
                     // notes: splice returns an Array, in this case, of only 1 element
                    newItem = $scope.tasks.items.splice(index, 1)[0];
                }
                // either the item was or wasn't in the list, add it to the top of list

                $scope.tasks.items.unshift(newItem);
            };

            var keyValue = barcode.split($scope.splitOn);
            if(keyValue.length === 2) {
                var key = keyValue[0];
                var value = parseInt(keyValue[1], 10);
                var filter = {fields: ['name', 'complete_name']};
                if (_.isEmpty(keyValue[0]) || _.isEmpty(keyValue[1])) {
                    return false;
                }
                // try to parse the barcode key and value,
                // to know what to do with and where to put it on model
                var contentType, field, now;
                switch(key) {
                case 'task':
                    contentType = false;
                    field = '_task_id';
                    break;
                case 'inter':
                    contentType = 'intervention';
                    field = 'project_id';
                    break;
                case 'task-type':
                    contentType = 'task_category';
                    field = 'category_id';
                    break;
                case 'agent':
                    contentType = 'user';
                    field = 'user_id';
                    break;
                case 'team':
                    field = 'team_id';
                    contentType = 'team';
                    break;
                case 'user':
                    field = '_user_id';
                    contentType = 'user';
                    break;
                case 'service':
                    field = 'service_id';
                    contentType = 'department';
                    break;
                case 'site':
                    field = 'site1';
                    contentType = 'site';
                    break;
                case 'equipment':
                    field = 'equipment_id';
                    contentType = 'equipment';
                    break;
                case 'date':
                    field = 'date_start';
                    now = moment().hour(8).minute(0).second(0);
                    if(key === 'now') {
                        // @TODO: we must find a dynamic way to init hours
                        value = now;
                    } else if (key === 'yest') {
                        value = now.add(-1, 'days');
                    }
                    break;
                case 'weekday':
                    // expects format weekday_x where x in [1..7]
                    field = 'date_start';
                    now = moment().hour(8).minute(0).second(0);
                    var isoWeekday = parseInt(keyValue[1], 10);
                    value = now.isoWeekday(isoWeekday);
                    break;
                case 'duration':
                    field = 'report_hours';
                    value = applyDurationCode($scope.model[field] || 0.0, keyValue[1]);
                    break;
                case 'remain':
                    field = 'remaining_hours';
                    if ($scope.model.project_id) {
                        value = applyDurationCode($scope.model[field] || 0.0, keyValue[1]);
                    } else {
                        value = false;
                    }
                    break;

                case 'time-start':
                    field = 'date_start';
                    // retrieve UTC value of date_start (or now())
                    var tz = swif.user.getTimeZone();
                    var dt = $scope.model[field] || moment.utc();
                    // then, compute timezone value
                    var dtTimezone = moment.utc(dt).tz(tz);
                    // next, according to the value, update the time value:
                    // - 'h15': set hours to '15'
                    // - 'm15': set minutes to '15'
                    // - 's15': set seconds to '15'
                    if (keyValue[1]) {
                        // split the first char (key) with the rest of string (value)
                        var _key = keyValue[1][0];
                        var val = parseInt(keyValue[1].substring(1), 10);
                        // apply changes to the correct attribute (hour, minute, second)
                        if (_key === 'h') {
                            dtTimezone.hour(val);
                        } else if(_key === 'm') {
                            dtTimezone.minute(val);
                        } else if(_key === 's') {
                            dtTimezone.second(val);
                        }
                    }
                    // finally, apply the value to the field (field expects UTC)
                    value = dtTimezone.utc();
                    break;
                case 'filter':
                    if (_.include(['draft  ', 'open', 'done'], keyValue[1])) {
                        $scope.filterState = keyValue[1];
                    } else {
                        $scope.filterDateRange = keyValue[1];
                    }
                    break;
                case 'action':
                    if (keyValue[1] === 'done') {
                        field = 'status';
                        value = 'done';

                    } else if (keyValue[1] === 'notfinished' || keyValue[1] === 'not-done') {
                        if ($scope.model.project_id) {
                            field = 'status';
                            value = 'notfinished';
                        } else {
                            swif.message.addWarning('Task out from intervention can only be finished');
                        }
                    } else if (keyValue[1] === 'notdone') {
                        if ($scope.model.project_id) {
                            field = 'status';
                            value = 'notdone';
                        } else {
                            swif.message.addWarning('Task out from intervention can only be finished');
                        }
                    } else if (keyValue[1] === 'validate') {
                        // perform the save to backend to report task hours
                        var defer;
                        var data = angular.copy($scope.model);
                        delete data.remaining_hours;
                        delete data.report_hours;
                        delete data.state;
                        if ($scope.form.$invalid) {
                            swif.message.addWarning('Invalid form ! please verify your input');
                        } else if ($scope.loading.task.loading) {
                            swif.message.addWarning('A survey is already in progress, please wait until it finishes');
                        } else if ($scope.model.id && $scope.model.actions.indexOf('report') === -1) {
                            swif.message.addWarning('You can not survey this task anymore. Perharps it is already done or cancelled, or you do not have rights');
                        } else if ($scope.model.state === 'cancelled') {
                            swif.message.addWarning('The task is cancelled, you can\'t survey it');
                        } else if ($scope.model.id) {
                            defer = swif.data.save(
                                'task', $scope.model.id,
                                data
                            );
                        } else {
                            defer = swif.data.create(
                                'task',
                                data
                            );
                        }
                        // then, move the task from the 'todo' list
                        if (defer) {
                            swif.message.loading($scope.loading.task);
                            defer.then (function (ret) {
                                $scope.model.id = $scope.model.id || ret.result;
                                swif.data.callKw(
                                    'task',
                                    'reportHours',
                                    [
                                        [$scope.model.id],
                                        {
                                            remaining_hours: $scope.model.remaining_hours,
                                            report_hours: $scope.model.report_hours
                                        }
                                    ]
                                ).then (function () {
                                    var newItem = angular.copy($scope.model);
                                    placeTaskOnTop(newItem);
                                    $scope.tasks.updateItem(newItem);

                                    $scope.tasks.currentItem = {};
                                    $scope.model = {};
                                    swif.message.loading($scope.loading.task, 'ok');
                                    swif.message.addInfo('The time survey is made');
                                }, function (err) {
                                    console.error(err);
                                    swif.message.addWarning('Failed to save the task');
                                    swif.message.loading($scope.loading.task, 'ko');
                                });
                            }, function (err) {
                                console.error(err);
                                swif.message.addWarning('Failed to save the task');
                                swif.message.loading($scope.loading.task, 'ko');
                            });
                        }
                    }
                    break;
                default:
                    swif.message.addWarning('Barcode scanner: Failed parsing value');
                    return false;
                }
                // if barcode refers to relational field, get it from server
                // and set the response to the model
                // else, for simple field, only set the value to the field
                if(contentType && field && value) {
                    swif.data.get(contentType, value, filter).then(function (ret) {
                        if(field === '_user_id') {
                            $scope.currentAgent = [ret.id, ret.complete_name || ret.name];

                        } else {
                            $scope.model[field] = [ret.id, ret.complete_name || ret.name];
                        }
                    });
                } else if(field === '_task_id') {
                    // specific callback for task type:
                    // filled all its data to the current model
                    $scope.tasks.setCurrent(value).then(function (item) {
                        placeTaskOnTop(item);
                    });

                } else if(field) {
                    $scope.model[field] = value;
                }
                return true;
            } else {
                return false;
            }
        }


        function updateFilters() {
            var ret = moduleInter.task.getFilters(
                $scope.model, $scope.currentIntervention
            );
            ret.user_id = {};
            $scope.filters = ret;
        }

        function initializeModel () {
            if($scope.tasks && $scope.tasks.currentItem) {
                _.assign($scope.model, $scope.tasks.currentItem);
                // @TODO: I hate to reset that on-the-fly, find a way to do it cleanly
                // (creating initialize() method for example)
                $scope.model.report_hours = $scope.model.planned_hours;
                $scope.model.state = 'done';
                delete $scope.model.remaining_hours;
            } else {
                $scope.model = {};
            }
            $scope.model.status = 'done';
            if (!$scope.model.user_id && $scope.currentAgentData.id) {
                $scope.model.user_id = [
                    $scope.currentAgentData.id,
                    $scope.currentAgentData.complete_name
                ];
            }
        }

        /*
         * @param dateRange: (str) key_value from barcode scanner to parse
         * @return: (Array) 2 items, date_start and date_end of the date-range filter
        */

        function _parseDareRange (dateRange) {
            var now = moment().hour(0).minute(0).second(0);
            // first, parse the dateRange value to split key and value
            var key = dateRange.substr(0, 2);
            var value = dateRange.substr(2, 1);
            value = parseInt(value, 10);
            var start, end;
            /* then, according to the key, parse the date range filter
             * the result may be converted to UTC dates
             * @TODO: instead of local timezone, must be parsed using date tools
             * as tasks are defined on working times, the TZ is not an issue here,
             * but don't do that for booking (in example) */
             // 'wd': we want a day-range from a specific weekday
            if (key === 'wd') {
                start = now.isoWeekday(value);
                end = moment(start).hour(23).minute(59).second(59);
            // 'w+': we want a week-range, relative to current week
            } else if (key === 'w+') {
                // place the 'cursor' on the next week from now
                start = now.add(value, 'weeks');
                // and place the 'cursor" on the first weekday
                start = start.isoWeekday(1);
                // week range is from 1st to last weekdays of current week
                end = moment(start).isoWeekday(7).hour(23).minute(59).second(59);
            // we want a day-range, relative to today
            } else if (key === 'd+') {
                start = now.add(value, 'days');
                end = moment(start).hour(23).minute(59).second(59);
            }

            return [
                start.format('YYYY-MM-DD HH:mm:00'),
                end.format('YYYY-MM-DD HH:mm:00')
            ];
        }

        // ensure collection exists, and if a user is selected, retrieve its tasks todo
        function createOrUpdateTasksCollection () {
            $scope.tasks = swif.collections.createCollection(
                'barcode_tasks',
                'task',
                {},
                {limitPerPage: 15, location: true}
            );
            var filter = {};
            if ($scope.currentAgentData.id) {
                filter = moduleInter.task._computeCollectionFilter($scope.currentAgentData);

            }
            if ($scope.filterDateRange) {
                var ranges = _parseDareRange($scope.filterDateRange);
                swif.data.addExtraFilter(filter, 'dateRange', ['date_start', '<=', ranges[1]]);
                swif.data.addExtraFilter(filter, 'dateRange', ['date_end', '>=', ranges[0]]);
            }
            if ($scope.filterState) {
                // i remove standard filters set by taskService
                // to set my own filters on the 'state' field
                filter.domain = [];
                var state = $scope.filterState;
                if (state === 'open') {
                    state = ['open'];
                } else {
                    state = [state];
                }
                swif.data.addExtraFilter(filter, 'specificState', ['state', 'in', state]);
            }
            if (filter) {
                _.assign($scope.tasks.currentFilter, filter);
            }
        }

        function watchCurrentItem (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                initializeModel();
            }
        }

        function watchUserId (newV, oldV) {
            if (!angular.equals(newV, oldV) || !$scope.model.service_id) {
                updateFilters();
            }
        }

        function watchServiceId(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                updateFilters();
                // if service was removed, we for the value with the user service
                if (oldV && !newV && $scope.model.user_id) {
                    swif.data.get('user', $scope.model.user_id[0], {fields: ['service_id']})
                    .then(function (data) {
                        $scope.model.service_id = data.service_id;
                    });
                }
            }
        }

        function watchCurrentAgent(newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                if(newV) {
                    var filter = {fields: ['name', 'complete_name']};
                    swif.data.get('user', newV[0], filter).then(function (data) {
                        $scope.currentAgentData = data;
                        createOrUpdateTasksCollection();
                        $scope.model.user_id = [newV[0], data.complete_name];
                    });
                } else {
                    $scope.currentAgentData = {};
                    createOrUpdateTasksCollection();
                }
            }
        }

        function watchProjectId(newV) {
            if (newV) {
                if ($scope.currentIntervention) {
                    if (newV[0] === $scope.currentIntervention.id) {
                        return;
                    }
                }
                var filter = {};
                filter.fields = angular.copy(moduleInter.task.PROJECT_ID_FIELDS);
                filter.fields.push('description');
                filter.fields.push('site1');
                filter.fields.push('equipment_id');
                filter.fields.push('swif_id');
                filter.fields.push('ask_id');
                swif.data.get('intervention', $scope.model.project_id[0], filter)
                .then(function (currentIntervention) {
                    $scope.currentIntervention = currentIntervention;
                    updateFilters();
                });
            } else {
                $scope.currentIntervention = false;
            }
        }

        /* According to newV, oldV and initial name value, update the name
          - if no name was filled, set a value
        */
        function watchCategoryId (newV, oldV) {
            var newVal = newV ? newV[1] : '';
            var oldVal = oldV ? oldV[1] : '';
            var newString = $scope.model.name;
            if(!$scope.model.name) {
                newString = newVal;
            }else if(!angular.equals(newVal, oldVal) && oldVal === $scope.model.name) {
                newString = newVal;
            }
            $scope.model.name = newString;
        }

        function watchGroupFilters(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                createOrUpdateTasksCollection();
            }
        }
    }

})();
